import { HotelPriceAdjustments } from "@website/accommodation-ui/hotel-card-new";
import { HotelReserveCancellationPoliciesPropertiesTypes } from "@website/accommodation-ui/hotel-reserve-cancellation-policies";
import { DatepickerCalendarDataType } from "@website/ui/datepicker";
import { CMSSeoContentData } from "@website/website-ui/services/seo-contents/cms-types";
import { ReservePropertiesTypes } from "@website/widget/reserve-nearby";
import { ReserveRatePropertiesTypes } from "@website/widget/reserve-rate";

export type RoomDataType = {
  id: number;
  title: string;
  capacity: number;
  extra_capacity: number;
  is_active: boolean;
  description: string;
  image: string;
  amenities: Array<{ id: number; title: string; icon: string }>;
  amenitiesGroup: AmenitiesGroup;
  search_weight: number;
  property_id: number;
  gallery: Array<unknown>;
  spaces: Array<{
    id: number;
    name: string;
    amenitiesGroup: Record<
      string,
      Array<{ id: number; title: string; description: string }>
    >;
  }>;
  summaries: {
    bathroom: string;
    bedding: string;
    info: string;
  };
  property: ReservePropertiesTypes;
  seo: {
    noIndex: boolean;
  };
};

type AmenitiesGroup = Record<string, Array<AmenityItem>>;
interface AmenityItem {
  id: number;
  title: string;
  icon: string;
  description?: string;
}

interface DateAvailability {
  date: string;
  availability: number;
  nonInstantAvailability: number;
  consumed: number;
  minStay: number;
  price?: number;
  dateType?: "Unknown" | "HighDemand" | "Nowruz" | "Normal";
  discount?: number;
}
export type HotelCalendarPropertiesType = {
  calender: Record<string, DateAvailability>;
  from: string;
  inventoryTypes: Array<string>;
  roomID: number;
  to: string;
};

export type HotelPagePropertiesType = {
  cancellationPoliciesData?: HotelReserveCancellationPoliciesPropertiesTypes;
  calendarData: DatepickerCalendarDataType;
  roomInfo: RoomDataType;
  seoData?: CMSSeoContentData;
  hotelRateData?: Pick<
    ReserveRatePropertiesTypes,
    "rate" | "rateCount" | "offerCount" | "rateDetail"
  >;
};

export type RoomPropertyResponseType = {
  adjustments?: HotelPriceAdjustments;
  room_id: number;
  from: string;
  to: string;
  base_price?: number;
  base_price_off?: number;
  daily_price: Record<
    string,
    {
      date: string;
      inventoryType: "OFFLINE";
      buyPrice: number;
      sellPrice: number;
      extraBedsPrice: number;
    }
  >;
  discount: number;
  extra_bed: number;
  min_stay: number;
  availability: number;
  total_price: number;
  extra_guest_base_price: number;
  total_local_price_off: number;
  total_extra_bed_price: number;
  adjusted_extra_capacity: number;
  instant?: boolean;
};

export type HotelVillaReviewDataType = {
  page: number;
  pageSize: number;
  result: [
    {
      id: number;
      helpfulSubmitted: boolean;
      comment: string;
      cons: [string];
      createdAt: string;
      avgRating: number;
      dateCount: number;
      passenger: string;
      propertyId: number;
      pros: [string];
      roomId: number;
      roomTitle: string;
      status: string;
      images: Array<string>;
    }
  ];
  total: number;
};

export type HotelReserveRateTypes =
  | "facilities"
  | "match"
  | "cleaning"
  | "friendly"
  | "priceQuality"
  | "hygiene"
  | "location";

export enum PersianVillaRatings {
  cleaning = "وضعیت نظافت",
  facilities = "وضعیت امکانات",
  match = "میزان تطابق با اطلاعات سایت",
  friendly = "برخورد میزبان و نحوه پذیرش",
  location = "موقعیت مکانی و دسترسی",
  priceQuality = "کیفیت اقامتگاه نسبت به قیمت"
}
export type HotelVillaRateDataType = Record<HotelReserveRateTypes, string> & {
  recommendationCount: number;
  recommendationType: HotelReserveRateTypes & "fullRate" & "recommendation";
  rateCount: number;
  overall: string;
};
